import styled from 'styled-components';
import { StyledEmbeddedWidgetCon, StyledProductItemCon } from '../../../skins';

export const StyledCheckboxEmbeddedWidgetCon = styled(
  StyledEmbeddedWidgetCon,
)``;

export const StyledCheckboxProductItemCon = styled(StyledProductItemCon)`
  & .mr-product-item__body {
    justify-content: start;
  }
`;

export const AddButtonCon = styled.div`
  margin-bottom: 32px;
  width: 100%;
  display: inline-flex;
`;
